<template>
  <b-row>
    <b-col cols="12">
      <ticket-edit-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import TicketEditForm from './TicketEditForm.vue'

export default {
  components: {
    BRow,
    BCol,
    TicketEditForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
